import { render, staticRenderFns } from "./RiddleGame.vue?vue&type=template&id=12f99245&"
import script from "./RiddleGame.vue?vue&type=script&lang=js&"
export * from "./RiddleGame.vue?vue&type=script&lang=js&"
import style0 from "./RiddleGame.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports